var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product"},_vm._l((_vm.lists),function(item){return _c('div',{key:item.id},[_c('v-card',{attrs:{"card":item},on:{"handleClick":_vm.handleClick}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }